import React from 'react';
import PropTypes from 'prop-types';
import { getTranslations } from '@translations';
import AccountIcon from '@tamagoshi/icons/Person';
import CartIcon from '@tamagoshi/icons/ShoppingCart';
import CloseIcon from '@tamagoshi/icons/Close';
import cn from 'classnames';
import Icon from '../Icon';
import Button from '../Button';

import styles from './styles/index.module.scss';

const Navigation = ({
  icon,
  url,
  fill,
  size,
  tag,
  className,
  children,
  onClick,
  dataQaSelect,
  dataQaIcon,
  isAuthenticated,
}) => {
  const translations = getTranslations();
  const iconClassName = cn({
    [styles.navigationIcon]: icon === 'list',
  });
  const iconContainerClassName = cn(className, styles.navigationItem, {
    [styles.burgerIcon]: icon === 'burgerMenu',
  });

  return (
    <div className={iconContainerClassName} data-qa={dataQaSelect}>
      <Button
        type="icon"
        tag={tag}
        href={url}
        className={styles.navigationTab}
        onClick={onClick}
      >
        {icon === 'account' && !isAuthenticated && (
          <div className={styles.connectItem}>
            {translations('header.subheader.account.login.button')}
          </div>
        )}
        {icon === 'account' && isAuthenticated && (
          <AccountIcon viewBox={size} data-qa={dataQaIcon} />
        )}

        {icon === 'basket' && (
          <CartIcon className={styles.navigationIconBasket} />
        )}

        {icon === 'close' && (
          <CloseIcon className={styles.navigationIconClose} />
        )}

        {icon !== 'account' && icon !== 'basket' && icon !== 'close' && (
          <Icon
            size={size}
            id={icon}
            fill={fill}
            data-qa={dataQaIcon}
            className={iconClassName}
          />
        )}

        {children}
      </Button>
    </div>
  );
};

Navigation.propTypes = {
  icon: PropTypes.string.isRequired,
  className: PropTypes.string,
  tag: PropTypes.string.isRequired,
  fill: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  url: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  dataQaSelect: PropTypes.string,
  dataQaIcon: PropTypes.string,
  isAuthenticated: PropTypes.bool,
};

Navigation.defaultProps = {
  url: undefined,
  className: undefined,
  children: null,
  onClick: () => {},
  fill: '#fff',
  size: 30,
  dataQaSelect: undefined,
  dataQaIcon: undefined,
  isAuthenticated: false,
};

Navigation.displayName = 'Navigation';

export default Navigation;
